export const AUTH_TOKEN:string="AUTH_TOKEN";
export const SERVER_ERROR_MESSAGE:string="ເກີດຂໍ້ຜິດພາດກະລຸນາລອງໃໝ່ອີກຄັ້ງ";
export const NOTIFICATION_ORDER_ID:string="notification_order_id";